
$(document).ready(function(){
  promoPopCookie();
  newsletterPopupA11y(); // WCAG 1.3.1, 2.4.3, 4.1.2 — dialog focus trap & restore
});

// WCAG 1.3.1, 2.4.3, 4.1.2 — Newsletter popup dialog accessibility.
// Installs a focus trap + Escape-to-close + focus restoration around
// #newsletter_popup WITHOUT modifying the existing open/close code paths
// (setTimeout-based open, two independent close click handlers).
// Visibility is observed via MutationObserver on the popup's style attr,
// which jQuery .fadeIn / .fadeOut mutate.
function newsletterPopupA11y() {
  var $popup = $('#newsletter_popup');
  if (!$popup.length) { return; }
  var popupEl = $popup[0];
  var $modal = $popup.find('.popup_modal');
  if (!$modal.length) { return; }
  var FOCUSABLE = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var previousFocus = null;
  var trapKeydown = null;

  function visibleFocusables() {
    return $modal.find(FOCUSABLE).filter(':visible');
  }

  function activateTrap() {
    if (trapKeydown) { return; } // idempotent
    previousFocus = document.activeElement;
    // Move focus into the dialog. Prefer first focusable; fall back to modal itself.
    var $focusables = visibleFocusables();
    var $target = $focusables.length ? $focusables.first() : $modal;
    setTimeout(function() { try { $target.trigger('focus'); } catch (_) {} }, 0);

    trapKeydown = function(e) {
      // Only act while popup is actually visible
      if (!$popup.is(':visible')) { return; }
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        // Delegate to the existing close path so cookie logic runs unchanged
        $popup.find('.close_popup').trigger('click');
        return;
      }
      if (e.key !== 'Tab' && e.keyCode !== 9) { return; }
      var focusables = visibleFocusables();
      if (!focusables.length) { e.preventDefault(); return; }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', trapKeydown, true);
  }

  function deactivateTrap() {
    if (trapKeydown) {
      document.removeEventListener('keydown', trapKeydown, true);
      trapKeydown = null;
    }
    // Restore focus to whatever had it before the popup opened
    if (previousFocus && typeof previousFocus.focus === 'function') {
      try { previousFocus.focus(); } catch (_) {}
    }
    previousFocus = null;
  }

  // Watch for fadeIn / fadeOut driven style changes
  if (typeof MutationObserver === 'function') {
    var mo = new MutationObserver(function() {
      if ($popup.is(':visible')) { activateTrap(); }
      else if (trapKeydown) { deactivateTrap(); }
    });
    mo.observe(popupEl, { attributes: true, attributeFilter: ['style'] });
  }
}


// Popup Js
  
  function promoPopCookie() {
  var promoCookie = "promo-showed";
  var promoDelay = $("#newsletter_popup").data("promo-delay");
  var promoExpiry = $("#newsletter_popup").data("promo-expiry");
  var my_setcookie = $.cookie('promo-showed');
    
  if ($("#newsletter_popup").data("promo-enabled")) {
    if (typeof my_setcookie != "undefined") {
      if (Cookies.get(promoCookie) !== "1") {
        setTimeout(function() {
          $('.popup_overlay').fadeIn();
          $('#newsletter_popup').fadeIn();  
        }, promoDelay);
      }
    }
  }

  $("#newsletter_popup .close_popup").click(function(e) {
    Cookies.set(promoCookie, "1", { expires: promoExpiry, path: "/" });	
    $('.popup_overlay').fadeOut();
    $('#newsletter_popup').fadeOut();
    e.preventDefault();
  });
    
    
  $('.popup_overlay').click(function () {
    Cookies.set(promoCookie, "1", { expires: promoExpiry, path: "/" });
	$(this).hide();
	$('#newsletter_popup').fadeOut();
	e.preventDefault();
  });
};

$(document).ready( function () {
    var $form = $('#mc-embedded-subscribe-form');
    if ( $form.length > 0 ) {
      $('form input[type="submit"]').bind('click', function ( event ) {
        
          if($('#mce-EMAIL').val()!=""){
            
            window.mc.ajaxOptions.success = function(response) {
              if(response.result == "error" ){
				var err_msg = response.msg;
				$('#mce-error-response').text(err_msg);
				$('#mce-error-response').show();
                $('#mc-embedded-subscribe-form').hide();
              }else{
        		$('#mc-embedded-subscribe-form').hide();
                $('.newsletter_text').hide();              
                $('.newsletter_success_text').fadeIn();
                $('.popup_wrapper .popup_modal .popup-body').css({"justify-content":"inherit"});
              }
			};      
          }
      });
    }  
    window.setInterval(function(){
      if($("#mce-error-response").text().indexOf("<a href") > 0) {
        var textToUpdate = $("#mce-error-response").text().slice(0,$("#mce-error-response").text().indexOf("<a href"));
        $("#mce-error-response").text(textToUpdate);
      }
    },500);
});

/* ----------------------------------------------------------------------------
 * Collection page custom sort
 * ----------------------------------------------------------------------------
 * Adds four custom options to the existing #sort_by dropdown:
 *   - in-stock-first
 *   - out-of-stock-first
 *   - size-ascending
 *   - size-descending
 *
 * Shopify's native `?sort_by=` only supports a fixed set of values, so these
 * options are kept entirely client-side. The picked value is persisted in
 * the URL under `?custom_sort=` (separate from `sort_by` so native filtering
 * and pagination links keep working) and re-applied on page load and after
 * the theme's ajax filter re-renders the grid.
 *
 * Sorting is performed by reordering the rendered `.product-block` DOM nodes
 * inside `.collection-product-list .grid` using `data-sort-*` attributes
 * emitted server-side. Size strings are mapped to a numeric rank via
 * SIZE_RANK so XS < S < M < L … sorts correctly; unknown / numeric sizes
 * fall through to a numeric/alphabetical comparator.
 *
 * Note on pagination: this reorders only the products on the current page,
 * which is the standard behaviour for theme-level custom sorts. For
 * collection-wide custom sort, raise `pagination_limit` or use a search
 * /products.json fetch — kept out of scope here for performance.
 * -------------------------------------------------------------------------- */
(function(){
  var CUSTOM_SORTS = ['in-stock-first', 'out-of-stock-first', 'size-ascending', 'size-descending'];

  // Lower index = smaller size. Add brand-specific sizes here as needed.
  var SIZE_RANK = {
    'xxxs': 0, 'xxs': 1, 'xs': 2, 's': 3, 'sm': 3, 'small': 3,
    'm': 4, 'md': 4, 'medium': 4,
    'l': 5, 'lg': 5, 'large': 5,
    'xl': 6, 'xxl': 7, '2xl': 7, '3xl': 8, 'xxxl': 8, '4xl': 9, '5xl': 10,
    'one size': 100, 'onesize': 100, 'os': 100
  };

  function sizeRank(raw){
    if(!raw){ return Number.POSITIVE_INFINITY; }
    var key = String(raw).trim().toLowerCase();
    if(key === ''){ return Number.POSITIVE_INFINITY; }
    if(Object.prototype.hasOwnProperty.call(SIZE_RANK, key)){ return SIZE_RANK[key]; }
    // numeric sizes (e.g. "32", "36", "8.5") — offset so they sort below the
    // lettered range by default but remain internally ordered.
    var num = parseFloat(key);
    if(!isNaN(num)){ return 1000 + num; }
    return Number.POSITIVE_INFINITY;
  }

  function getCustomSortFromUrl(){
    var match = location.search.match(/[?&]custom_sort=([^&]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setCustomSortInUrl(value){
    var url = new URL(location.href);
    if(value){
      url.searchParams.set('custom_sort', value);
    } else {
      url.searchParams.delete('custom_sort');
    }
    window.history.replaceState({}, '', url.toString());
  }

  function isCustomSort(value){
    return CUSTOM_SORTS.indexOf(value) !== -1;
  }

  function applyCustomSort(value){
    var $grid = $('.collection-product-list .grid').first();
    if(!$grid.length){ return; }
    var $items = $grid.children('.product-block').detach();
    var arr = $items.toArray();

    arr.sort(function(a, b){
      var ad = a.dataset, bd = b.dataset;
      switch(value){
        case 'in-stock-first':
          return (parseInt(bd.sortAvailable,10)||0) - (parseInt(ad.sortAvailable,10)||0);
        case 'out-of-stock-first':
          return (parseInt(ad.sortAvailable,10)||0) - (parseInt(bd.sortAvailable,10)||0);
        case 'size-ascending':
          return sizeRank(ad.sortMinSize) - sizeRank(bd.sortMinSize);
        case 'size-descending':
          return sizeRank(bd.sortMaxSize) - sizeRank(ad.sortMaxSize);
      }
      return 0;
    });

    $grid.append(arr);
  }

  function syncDropdown(value){
    var $sel = $('select[name="sort_by"]');
    if(!$sel.length){ return; }
    if(value && $sel.find('option[value="' + value + '"]').length){
      $sel.val(value);
      // Re-sync select2 styling if present.
      if($sel.data('select2')){ $sel.trigger('change.select2'); }
    }
  }

  function init(){
    var current = getCustomSortFromUrl();
    if(current && isCustomSort(current)){
      syncDropdown(current);
      applyCustomSort(current);
    }
  }

  // Intercept change on the sort dropdown BEFORE the theme's CollectionTemplate
  // handler navigates away. Using capture phase + stopImmediatePropagation when
  // a custom sort is chosen keeps the page in place.
  $(document).on('change', 'select[name="sort_by"]', function(evt){
    var value = $(this).val();
    if(isCustomSort(value)){
      evt.stopImmediatePropagation();
      setCustomSortInUrl(value);
      applyCustomSort(value);
    } else {
      // Switching back to a native sort — clear the custom param so it doesn't
      // re-apply on top of Shopify's response.
      setCustomSortInUrl('');
    }
  });

  // Re-apply after the theme's ajax filter swaps in new product DOM.
  // CollectionTemplate empties + re-appends the container; we listen for any
  // mutation on it and re-run if a custom sort is active.
  function observeAjax(){
    var container = document.querySelector('[data-ajax-products]');
    if(!container || !window.MutationObserver){ return; }
    var debounceTimer = null;
    var observer = new MutationObserver(function(){
      var current = getCustomSortFromUrl();
      if(!current || !isCustomSort(current)){ return; }
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function(){
        syncDropdown(current);
        applyCustomSort(current);
      }, 50);
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  $(document).ready(function(){
    init();
    observeAjax();
  });
})();

/* ----------------------------------------------------------------------------
 * Quick Add hover CTA
 * ----------------------------------------------------------------------------
 * The Liquid layer already renders `.product-block__quicklook-btn` when the
 * theme-level `quickbuy_buttons_toggle` is on. The hover styling lives in
 * custom.css; this block only handles small UX niceties:
 *   - Hide on touch devices (mobile) where hover doesn't apply.
 * -------------------------------------------------------------------------- */
(function(){
  if('ontouchstart' in window || (navigator.maxTouchPoints||0) > 0){
    document.documentElement.classList.add('is-touch');
  }
})();

/* ----------------------------------------------------------------------------
 * Premium custom sort dropdown
 * ----------------------------------------------------------------------------
 * Replaces the boring native <select> with a styled button + panel while
 * keeping the original select in the DOM (visually hidden). All user
 * interaction is forwarded onto the native select via .val()+change so the
 * existing theme handler (CollectionTemplate.onSortByChange) and the custom
 * sort interceptor above keep working untouched.
 * -------------------------------------------------------------------------- */
(function(){
  function buildPanel($dropdown, $select){
    var $panel = $dropdown.find('[data-custom-dropdown-panel]');
    $panel.empty();
    $select.find('option').each(function(){
      var $opt = $(this);
      var li = document.createElement('li');
      li.className = 'collection-toolbar__sort-option';
      li.setAttribute('role', 'option');
      li.setAttribute('data-value', $opt.attr('value'));
      li.setAttribute('tabindex', '0');
      li.textContent = $opt.text();
      if($opt.is(':selected')){ li.setAttribute('aria-selected', 'true'); }
      $panel.append(li);
    });
  }

  function syncLabel($dropdown, $select){
    var label = $select.find('option:selected').text() || $select.find('option').first().text();
    $dropdown.find('[data-custom-dropdown-value]').text(label);
    $dropdown.find('[data-custom-dropdown-panel] [data-value]').each(function(){
      if(this.getAttribute('data-value') === $select.val()){
        this.setAttribute('aria-selected', 'true');
      } else {
        this.removeAttribute('aria-selected');
      }
    });
  }

  function openPanel($dropdown){
    $dropdown.attr('data-open', 'true');
    $dropdown.find('[data-custom-dropdown-trigger]').attr('aria-expanded', 'true');
    $dropdown.find('[data-custom-dropdown-panel]').prop('hidden', false);
  }

  function closePanel($dropdown){
    $dropdown.attr('data-open', 'false');
    $dropdown.find('[data-custom-dropdown-trigger]').attr('aria-expanded', 'false');
    $dropdown.find('[data-custom-dropdown-panel]').prop('hidden', true);
  }

  function initDropdown(){
    var $dropdown = $('[data-custom-dropdown]').first();
    var $select = $('select[name="sort_by"]').first();
    if(!$dropdown.length || !$select.length){ return; }
    buildPanel($dropdown, $select);
    syncLabel($dropdown, $select);
  }

  // Toggle open/close
  $(document).on('click', '[data-custom-dropdown-trigger]', function(evt){
    evt.stopPropagation();
    var $dropdown = $(this).closest('[data-custom-dropdown]');
    if($dropdown.attr('data-open') === 'true'){
      closePanel($dropdown);
    } else {
      openPanel($dropdown);
    }
  });

  // Pick an option — forward onto the native select so the change handler fires
  $(document).on('click', '[data-custom-dropdown-panel] [data-value]', function(){
    var value = this.getAttribute('data-value');
    var $dropdown = $(this).closest('[data-custom-dropdown]');
    var $select = $('select[name="sort_by"]').first();
    if(!$select.length){ return; }
    $select.val(value).trigger('change');
    // The change handler may navigate (native sorts) or stay on-page (custom
    // sorts). Either way, reflect the new state in the trigger immediately.
    syncLabel($dropdown, $select);
    closePanel($dropdown);
  });

  // Keyboard support: ↑ ↓ Enter Escape
  $(document).on('keydown', '[data-custom-dropdown-trigger]', function(evt){
    var $dropdown = $(this).closest('[data-custom-dropdown]');
    if(evt.key === 'ArrowDown' || evt.key === 'Enter' || evt.key === ' '){
      evt.preventDefault();
      openPanel($dropdown);
      $dropdown.find('[data-custom-dropdown-panel] [data-value]').first().focus();
    } else if(evt.key === 'Escape'){
      closePanel($dropdown);
    }
  });

  $(document).on('keydown', '[data-custom-dropdown-panel] [data-value]', function(evt){
    var $items = $(this).closest('[data-custom-dropdown-panel]').find('[data-value]');
    var idx = $items.index(this);
    if(evt.key === 'ArrowDown'){
      evt.preventDefault();
      $items.eq(Math.min(idx + 1, $items.length - 1)).focus();
    } else if(evt.key === 'ArrowUp'){
      evt.preventDefault();
      $items.eq(Math.max(idx - 1, 0)).focus();
    } else if(evt.key === 'Enter' || evt.key === ' '){
      evt.preventDefault();
      this.click();
    } else if(evt.key === 'Escape'){
      evt.preventDefault();
      var $dropdown = $(this).closest('[data-custom-dropdown]');
      closePanel($dropdown);
      $dropdown.find('[data-custom-dropdown-trigger]').focus();
    }
  });

  // Click outside closes
  $(document).on('click', function(evt){
    var $dropdown = $('[data-custom-dropdown][data-open="true"]');
    if(!$dropdown.length){ return; }
    if(!$.contains($dropdown[0], evt.target)){
      closePanel($dropdown);
    }
  });

  // Re-init after the theme's ajax filter swaps in new product DOM, since the
  // native <select>'s selected option will have moved.
  $(document).ready(function(){
    initDropdown();
    var container = document.querySelector('[data-ajax-products]');
    if(container && window.MutationObserver){
      var observer = new MutationObserver(function(){
        var $dropdown = $('[data-custom-dropdown]').first();
        var $select = $('select[name="sort_by"]').first();
        if($dropdown.length && $select.length){ syncLabel($dropdown, $select); }
      });
      observer.observe(container, { childList: true, subtree: true });
    }
  });
})();

/* ============================================================================
 * Multi-select collection tag filters
 * --------------------------------------------------------------------------
 * Replaces the legacy single-select dropdowns on collection pages. Each
 * `[data-multi-filter]` group renders its allowed tags as checkbox chips.
 * On any change we:
 *   1. collect every checked value across every group on the page,
 *   2. build a Shopify multi-tag URL: `/collections/<handle>/tag1+tag2+...`,
 *   3. preserve `sort_by` / `custom_sort` query params,
 *   4. AJAX-swap the product grid via the same `[data-ajax-products]`
 *      container the theme already uses (falls back to a full navigation
 *      if the container is not in ajax mode).
 *
 * Combination model:
 *   - Within a group: multi-select (e.g. "Black + White" in the Colour group).
 *   - Across groups: Shopify natively ANDs them in the resulting URL.
 *
 * Active-state styling is applied via the `.is-active` class on the chip's
 * <label>; styled in custom.css with a softer weight than the previous
 * dropdown rendered the selected option.
 * ========================================================================== */
(function multiFilterInit(){
  var SELECTOR = '[data-multi-filter]';
  var INPUT_SELECTOR = SELECTOR + ' input[type="checkbox"]';
  var BAR_SELECTOR = '[data-applied-filters]';

  function root(){
    var $any = $(SELECTOR).first();
    if($any.length){ return $any.attr('data-filter-root'); }
    var $bar = $(BAR_SELECTOR).first();
    return $bar.length ? $bar.attr('data-filter-root') : null;
  }

  function gatherTags(){
    var tags = [];
    $(INPUT_SELECTOR + ':checked').each(function(){
      var v = this.value;
      if(v && tags.indexOf(v) === -1){ tags.push(v); }
    });
    return tags;
  }

  function getQueryParam(name){
    if(!location.search){ return null; }
    var pairs = location.search.substr(1).split('&');
    for(var i = 0; i < pairs.length; i++){
      var pair = pairs[i].split('=');
      if(decodeURIComponent(pair[0]) === name){
        return decodeURIComponent(pair[1] || '');
      }
    }
    return null;
  }

  function preservedQueryString(opts){
    opts = opts || {};
    if(!location.search){ return ''; }
    var keep = [];
    location.search.substr(1).split('&').forEach(function(pair){
      if(!pair){ return; }
      var k = pair.split('=')[0];
      if(k === 'sort_by' && opts.dropSortBy){ return; }
      if(k === 'custom_sort' && opts.dropCustomSort){ return; }
      if(k === 'sort_by' || k === 'custom_sort'){ keep.push(pair); }
    });
    return keep.length ? ('?' + keep.join('&')) : '';
  }

  function buildUrl(opts){
    var base = root();
    if(!base){ return null; }
    var tags = gatherTags();
    return base + (tags.length ? tags.join('+') : '') + preservedQueryString(opts);
  }

  function applyActiveStyling(){
    $(SELECTOR + ' .filter-checklist__label').each(function(){
      var $label = $(this);
      var checked = $label.find('input[type="checkbox"]').is(':checked');
      $label.toggleClass('is-active', checked);
    });
  }

  // -------------------------------------------------------------------------
  // Applied filters bar — rebuilds on every state change so the bar mirrors
  // the current filter + sort selections exactly. Source of truth is the
  // checkboxes (for tags), the native sort <select> (for native sort), and
  // the `?custom_sort=` query param (for client-side custom sorts).
  // -------------------------------------------------------------------------
  function defaultSortValue(){
    return $('select[name="sort_by"]').attr('data-default-sort') || 'manual';
  }

  function getActiveSort(){
    var customSort = getQueryParam('custom_sort');
    if(customSort){
      var $custOpt = $('select[name="sort_by"] option[value="' + customSort + '"]');
      return { kind: 'custom', value: customSort, label: ($custOpt.text() || customSort).trim() };
    }
    var urlSort = getQueryParam('sort_by');
    if(urlSort && urlSort !== defaultSortValue()){
      var $opt = $('select[name="sort_by"] option[value="' + urlSort + '"]');
      if($opt.length){ return { kind: 'native', value: urlSort, label: $opt.text().trim() }; }
      return { kind: 'native', value: urlSort, label: urlSort };
    }
    return null;
  }

  function resetSortUi(){
    var defVal = defaultSortValue();
    var $select = $('select[name="sort_by"]').first();
    if($select.length){
      $select.val(defVal);
      // Sync the custom toolbar dropdown's visible label without re-triggering
      // the theme's onSortByChange handler (which would re-add sort_by=default
      // to the URL we just cleaned).
      var $dropdown = $('[data-custom-dropdown]').first();
      if($dropdown.length){
        var defaultLabel = $select.find('option[value="' + defVal + '"]').text() || defVal;
        $dropdown.find('[data-custom-dropdown-value]').text(defaultLabel);
        $dropdown.find('[data-custom-dropdown-panel] [data-value]').each(function(){
          if(this.getAttribute('data-value') === defVal){
            this.setAttribute('aria-selected', 'true');
          } else {
            this.removeAttribute('aria-selected');
          }
        });
      }
    }
  }

  function chipLabelFromCheckbox(input){
    var $text = $(input).closest('label').find('.filter-checklist__text');
    return ($text.text() || input.value).trim();
  }

  function buildFilterChip(value, label){
    var $btn = $('<button type="button" class="applied-filter-chip"></button>')
      .attr('data-remove-filter', '')
      .attr('data-value', value)
      .attr('aria-label', 'Remove filter ' + label);
    $btn.append($('<span class="applied-filter-chip__text"></span>').text(label));
    $btn.append($('<span class="applied-filter-chip__x" aria-hidden="true">×</span>'));
    return $('<li class="applied-filters-bar__item"></li>').append($btn);
  }

  function buildSortChip(sortInfo){
    var sortLead = ($('select[name="sort_by"]').closest('.styled-dropdown').find('label').text() || 'Sort by').trim();
    var $btn = $('<button type="button" class="applied-filter-chip applied-filter-chip--sort"></button>')
      .attr('data-remove-sort', '')
      .attr('data-sort-kind', sortInfo.kind)
      .attr('aria-label', 'Remove sort ' + sortInfo.label);
    $btn.append($('<span class="applied-filter-chip__label"></span>').text(sortLead + ':'));
    $btn.append($('<span class="applied-filter-chip__text"></span>').text(sortInfo.label));
    $btn.append($('<span class="applied-filter-chip__x" aria-hidden="true">×</span>'));
    return $('<li class="applied-filters-bar__item applied-filters-bar__item--sort" data-sort-chip></li>').append($btn);
  }

  function rebuildBar(){
    var $bar = $(BAR_SELECTOR);
    if(!$bar.length){ return; }
    var $list = $bar.find('[data-applied-list]');
    $list.empty();

    var $checked = $(INPUT_SELECTOR + ':checked');
    $checked.each(function(){
      $list.append(buildFilterChip(this.value, chipLabelFromCheckbox(this)));
    });

    var sortInfo = getActiveSort();
    if(sortInfo){ $list.append(buildSortChip(sortInfo)); }

    var hasFilters = $checked.length > 0;
    var $clear = $bar.find('[data-clear-filters]');
    if(hasFilters){ $clear.removeAttr('hidden'); } else { $clear.attr('hidden', ''); }

    if(hasFilters || sortInfo){ $bar[0].removeAttribute('hidden'); }
    else { $bar[0].setAttribute('hidden', ''); }
  }

  // -------------------------------------------------------------------------
  // AJAX swap
  // -------------------------------------------------------------------------
  function changeUrl(url){
    if(!url){ return; }
    var $ajax = $('[data-ajax-products]');
    var isAjax = $ajax.length && $ajax.data('ajax-products');
    if(!isAjax){ window.location = url; return; }

    if($(window).width() <= 930){
      $('html, body').animate({ scrollTop: $ajax.offset().top - 120 }, 600);
    }
    $ajax.css({ height: $ajax.height(), opacity: 0 });

    var transition = $ajax.css('transition-duration');
    var delay = 0;
    if(transition){
      delay = transition.indexOf('ms') > -1 ? parseInt(transition, 10) : parseFloat(transition) * 1000;
    }
    if(isNaN(delay) || delay < 0){ delay = 0; }

    setTimeout(function(){
      $.get(url, function(data){
        var $data = $('<div>').append($.parseHTML(data));
        var $products = $data.find('[data-ajax-products]').children();
        $ajax.empty().append($products).css({ height: '', opacity: '' });
        var title = $data.find('title:first').text();
        if(title){ document.title = title; }
        // Use the same state token the theme's CollectionTemplate.onWindowPopState
        // listens for so the browser back button reloads to the correct URL.
        window.history.pushState('themeChangeUrl', title, url);
        rebuildBar();
      }).fail(function(){ window.location = url; });
    }, delay);
  }

  // -------------------------------------------------------------------------
  // Event wiring
  // -------------------------------------------------------------------------
  // Chip checked/unchecked inside a filter group.
  $(document).on('change', INPUT_SELECTOR, function(){
    applyActiveStyling();
    rebuildBar();
    changeUrl(buildUrl());
  });

  // × on an applied filter chip — uncheck the matching checkbox(es), update.
  $(document).on('click', '[data-remove-filter]', function(){
    var value = $(this).attr('data-value');
    if(!value){ return; }
    $(INPUT_SELECTOR + '[value="' + value + '"]').prop('checked', false);
    applyActiveStyling();
    rebuildBar();
    changeUrl(buildUrl());
  });

  // × on the sort chip — drop sort_by AND custom_sort from the URL, keep tags.
  // Also reset the toolbar's sort UI to its default state so the page reflects
  // the cleared sort without a full reload.
  $(document).on('click', '[data-remove-sort]', function(){
    var url = buildUrl({ dropSortBy: true, dropCustomSort: true });
    if(!url){ return; }
    resetSortUi();
    rebuildBar();
    changeUrl(url);
  });

  // "Clear all" — only clears tag filters; sort is intentionally preserved
  // so the customer's sort preference isn't surprise-reset.
  $(document).on('click', '[data-clear-filters]', function(){
    $(INPUT_SELECTOR).prop('checked', false);
    applyActiveStyling();
    rebuildBar();
    changeUrl(buildUrl());
  });

  $(document).ready(function(){
    applyActiveStyling();
    rebuildBar();
  });
})();

/* ============================================================================
 * Collection filter preview (client-side)
 * --------------------------------------------------------------------------
 * Pure DOM filter + sort engine shared by both preview variants:
 *   - Preview 1: single dropdown panel housing all three filter sections.
 *   - Preview 2: three independent side-by-side dropdowns.
 *
 * Filters (combined with AND logic):
 *   - Availability: in stock / out of stock (data-sort-available)
 *   - Size: exact match against data-sizes-available
 *   - Sort by price: low → high / high → low (data-sort-price)
 *
 * No URL writes, no AJAX, no page reload. The whole engine lives behind
 * `[data-filter-preview]` so it stays inert until a preview is enabled in
 * the section settings.
 * ========================================================================== */
(function collectionFilterPreviewInit(){
  var $container = $('[data-filter-preview]');
  if(!$container.length){ return; }

  var SIZE_RANK = {
    'xxxs': 0, 'xxs': 1, 'xs': 2, 's': 3, 'sm': 3, 'small': 3,
    'm': 4, 'md': 4, 'medium': 4,
    'l': 5, 'lg': 5, 'large': 5,
    'xl': 6, 'xxl': 7, '2xl': 7, '3xl': 8, 'xxxl': 8, '4xl': 9, '5xl': 10,
    'one size': 100, 'onesize': 100, 'os': 100
  };

  function sizeRank(raw){
    if(!raw){ return Number.POSITIVE_INFINITY; }
    var key = String(raw).trim().toLowerCase();
    if(key === ''){ return Number.POSITIVE_INFINITY; }
    if(Object.prototype.hasOwnProperty.call(SIZE_RANK, key)){ return SIZE_RANK[key]; }
    var num = parseFloat(key);
    if(!isNaN(num)){ return 1000 + num; }
    return Number.POSITIVE_INFINITY;
  }

  // Filter state lives in memory but is mirrored to the URL via three
  // dedicated query params so that:
  //   1. Pagination preserves filters — Shopify's `paginate.next.url` and
  //      friends carry the query string forward, so clicking Next on
  //      page 1 with `?filter_stock=in` lands on `?page=2&filter_stock=in`
  //      with no extra work.
  //   2. Direct/refreshed URLs hydrate the same filter state.
  //   3. Sharing a filtered URL works.
  // We use replaceState (not pushState) so toggling chips doesn't pollute
  // history; the user can still hit Back to leave the filtered URL.
  var URL_PARAMS = { stock: 'filter_stock', size: 'filter_size', sort: 'filter_sort' };
  // Default sort is 'new' (New Arrivals) per the filter-bar spec — applied
  // on initial render unless an explicit `filter_sort` URL param overrides it.
  var DEFAULT_SORT = 'new';
  var state = { stock: '', size: '', sort: DEFAULT_SORT };

  // Guards the MutationObserver below from re-entering apply() in response
  // to its own DOM writes. Without this, every sort call would trigger the
  // observer, which would call apply() again, which would re-sort the same
  // cards — a feedback loop that left product cards in a state of constant
  // re-shuffling and made the hover-image crossfade flicker.
  var isApplying = false;

  function $grid(){ return $('.collection-product-list .grid').first(); }
  function $cards(){ return $grid().children('.product-block'); }

  // -----------------------------------------------------------------------
  // URL state persistence
  // -----------------------------------------------------------------------
  function readParam(name){
    if(!location.search){ return ''; }
    var pairs = location.search.substr(1).split('&');
    for(var i = 0; i < pairs.length; i++){
      var pair = pairs[i].split('=');
      if(decodeURIComponent(pair[0]) === name){
        return decodeURIComponent((pair[1] || '').replace(/\+/g, ' '));
      }
    }
    return '';
  }

  function hydrateStateFromUrl(){
    state.stock = readParam(URL_PARAMS.stock);
    state.size = readParam(URL_PARAMS.size);
    var sortParam = readParam(URL_PARAMS.sort);
    state.sort = sortParam || DEFAULT_SORT;

    // The size value in the URL may not match the case of the option
    // rendered in the DOM (e.g. `?filter_size=m` vs. an option with
    // value "M"). Normalise to whatever case the matching option uses
    // so syncUi can highlight it via a straight string compare.
    if(state.size){
      var target = state.size.toLowerCase();
      var $opts = $container.find('[data-filter-group="size"] [data-filter-value]');
      $opts.each(function(){
        var v = this.getAttribute('data-filter-value') || '';
        if(v && v.toLowerCase() === target){ state.size = v; return false; }
      });
    }
  }

  function writeStateToUrl(){
    if(!window.history || !window.history.replaceState){ return; }
    try {
      var url = new URL(location.href);
      Object.keys(URL_PARAMS).forEach(function(key){
        var param = URL_PARAMS[key];
        if(state[key]){ url.searchParams.set(param, state[key]); }
        else { url.searchParams.delete(param); }
      });
      // Preserve existing history state (e.g. the 'themeChangeUrl' token
      // the theme's onWindowPopState listens for).
      window.history.replaceState(window.history.state, '', url.toString());
    } catch(e){ /* URL ctor unsupported on very old browsers — skip silently */ }
  }

  // -----------------------------------------------------------------------
  // Populate the size dropdown from the actual product cards. We aggregate
  // sizes across the whole rendered grid so the dropdown always reflects
  // what's actually available on this collection page.
  // -----------------------------------------------------------------------
  function uniqueSizes(){
    var seen = {};
    var sizes = [];
    $cards().each(function(){
      var raw = this.getAttribute('data-sizes-available') || '';
      raw.split('|').forEach(function(s){
        s = s.trim();
        if(!s){ return; }
        var key = s.toLowerCase();
        if(!seen[key]){ seen[key] = true; sizes.push(s); }
      });
    });
    sizes.sort(function(a, b){
      var ra = sizeRank(a), rb = sizeRank(b);
      if(ra === rb){ return a.localeCompare(b); }
      return ra - rb;
    });
    return sizes;
  }

  function populateSizeOptions(){
    var sizes = uniqueSizes();
    $container.find('[data-filter-size-options]').each(function(){
      var $host = $(this);
      // Keep the seed "All" option that ships in the snippet — only inject
      // the dynamic sizes after it.
      $host.find('li').not(':first').remove();
      sizes.forEach(function(s){
        var $btn = $('<button type="button" class="filter-preview__option" role="option" aria-selected="false">')
          .attr('data-filter-value', s)
          .text(s);
        $host.append($('<li>').append($btn));
      });
    });
  }

  // -----------------------------------------------------------------------
  // Empty-state UI: a clean "no products found" message inserted right
  // after the .grid when the active filter combo yields zero visible
  // cards. The element is created lazily on first miss and reused after
  // that — hidden via the `[hidden]` attribute when results return.
  // -----------------------------------------------------------------------
  function renderEmptyState(visibleCount){
    var $g = $grid();
    if(!$g.length){ return; }
    var $msg = $g.parent().find('.filter-preview__empty').first();
    if(visibleCount > 0){
      if($msg.length){ $msg.attr('hidden', ''); }
      return;
    }
    if(!$msg.length){
      $msg = $(
        '<div class="filter-preview__empty" role="status" aria-live="polite">' +
          '<p class="filter-preview__empty-title">No products match the current filters.</p>' +
          '<p class="filter-preview__empty-hint">Try a different size, switch off IN STOCK ONLY, or clear all filters.</p>' +
          '<button type="button" class="filter-preview__empty-clear" data-filter-clear>Clear all filters</button>' +
        '</div>'
      );
      $g.after($msg);
    }
    $msg.removeAttr('hidden');
  }

  // -----------------------------------------------------------------------
  // Apply current state to the grid (filter then sort).
  // -----------------------------------------------------------------------
  function apply(){
    // Sync UI first so dropdown triggers, active option highlights, the
    // clear-all button and the in-stock toggle ALL reflect current state
    // — even when the grid is empty or every product just got filtered
    // out. Previously this lived at the bottom of apply() behind two
    // early returns, which is what made the size dropdown sometimes not
    // visually reflect the chosen size (Issue 1).
    syncUi();

    var $g = $grid();
    if(!$g.length){ renderEmptyState(0); return; }
    var $items = $cards();
    if(!$items.length){ renderEmptyState(0); return; }

    isApplying = true;
    var visibleCount = 0;
    try {
      var sizeLc = state.size.toLowerCase();

      $items.each(function(){
        var d = this.dataset;
        var pass = true;

        if(state.stock === 'in' && parseInt(d.sortAvailable, 10) !== 1){ pass = false; }

        if(pass && sizeLc){
          // No special-case for accessories any more. If a product has
          // no Size option at all (typical accessory), `sizes_available`
          // is empty, so `indexOf(sizeLc)` returns -1 and the product
          // is hidden naturally. Accessories therefore drop out the
          // moment a specific size is picked, and reappear only when
          // SIZE = ALL (sizeLc === ''). This matches the spec exactly:
          // we don't branch on accessory/non-accessory — we branch on
          // "does this product carry the selected size variant?".
          //
          // Match is always case-insensitive (XS / xs / Xs all match)
          // because both sides were already lowercased above.
          var listAvail = (d.sizesAvailable || '').toLowerCase().split('|').map(function(s){ return s.trim(); }).filter(function(s){ return s; });
          var listInStock = (d.sizesInStock || '').toLowerCase().split('|').map(function(s){ return s.trim(); }).filter(function(s){ return s; });
          var hasSize = listAvail.indexOf(sizeLc) > -1;
          var hasSizeInStock = listInStock.indexOf(sizeLc) > -1;

          if(state.stock === 'in'){
            // Size + IN STOCK ONLY = the product must carry an IN-STOCK
            // variant of exactly the selected size. (Variant-level — the
            // product-level `product.available` flag is too coarse: it
            // returns true as soon as any variant is in stock, even if
            // the shopper's chosen size is sold out.)
            if(!hasSizeInStock){ pass = false; }
          } else {
            // IN STOCK OFF → the product must carry the size as a variant
            // option, regardless of stock status for that variant.
            if(!hasSize){ pass = false; }
          }
        }

        // Toggle via inline display so we don't fight any other class-based
        // visibility rules from the theme.
        this.style.display = pass ? '' : 'none';
        if(pass){ visibleCount++; }
      });

      // Sort modes: 'new' = newest-first by data-sort-created,
      // 'popular' = original collection order (lowest index first — i.e.,
      // the merchant-curated ordering Shopify returns), 'price-asc' /
      // 'price-desc' by data-sort-price.
      var sortKey = state.sort || DEFAULT_SORT;
      if(sortKey === 'new' || sortKey === 'popular' || sortKey === 'price-asc' || sortKey === 'price-desc'){
        var arr = $items.toArray();
        var sorted = arr.slice().sort(function(a, b){
          if(sortKey === 'price-asc' || sortKey === 'price-desc'){
            var pa = parseInt(a.dataset.sortPrice, 10) || 0;
            var pb = parseInt(b.dataset.sortPrice, 10) || 0;
            return sortKey === 'price-asc' ? pa - pb : pb - pa;
          }
          if(sortKey === 'new'){
            var ca = parseInt(a.dataset.sortCreated, 10) || 0;
            var cb = parseInt(b.dataset.sortCreated, 10) || 0;
            return cb - ca;
          }
          // popular → original collection order
          var oa = parseInt(a.dataset.sortCollectionOrder, 10) || 0;
          var ob = parseInt(b.dataset.sortCollectionOrder, 10) || 0;
          return oa - ob;
        });
        // Only touch the DOM if the order actually changed. A no-op reorder
        // still fires childList mutations and (more importantly) tears
        // down + rebuilds composition layers on the image elements, which
        // is what was causing the hover crossfade to flash white.
        var changed = false;
        for(var i = 0; i < arr.length; i++){
          if(arr[i] !== sorted[i]){ changed = true; break; }
        }
        if(changed){
          var frag = document.createDocumentFragment();
          sorted.forEach(function(el){ frag.appendChild(el); });
          $g[0].appendChild(frag);
        }
      }

      // Re-assign visible-position "row-start" classes so the 3-column
      // uniform grid clearfix lands on the right cards in the visible
      // flow. The theme's `:nth-child(3n+1)` rule counts hidden cards
      // too, which is what was collapsing the layout to 2 columns when
      // a filter took some cards out. See `.has-client-filter` block in
      // custom.css for the matching CSS overrides. Runs AFTER the sort
      // above so re-ordered cards get their row-start class based on
      // their final DOM position. Re-queries $cards() so we iterate
      // in current DOM order rather than the pre-sort $items snapshot.
      var visibleIdx = 0;
      $cards().each(function(){
        var $c = $(this);
        if(this.style.display === 'none'){
          $c.removeClass('is-row-start');
          return;
        }
        if(visibleIdx % 3 === 0){ $c.addClass('is-row-start'); }
        else { $c.removeClass('is-row-start'); }
        visibleIdx++;
      });

      // Carry the active size into every product link on the page so when
      // the shopper clicks through, the PDP can read `?filter_size=…` and
      // auto-select that size. (Issue 4.) See the
      // `autoSelectFilteredSizeOnPDP` IIFE further down for the PDP-side
      // handling.
      rewriteProductLinks();

      // Empty-state UI: when the active filter combo has no matches,
      // show a clean "no products found" message in place of an empty
      // grid. Re-sync UI at the bottom so any state changes that
      // happened during the filter pass (none currently, but defensive
      // for future tweaks) are reflected.
      renderEmptyState(visibleCount);
      syncUi();
    } finally {
      // Release the observer guard on the next tick so any mutations our
      // writes queued have a chance to fire and be ignored before further
      // user-driven changes are processed normally. The window must be
      // longer than the observer's debounce (50ms) so that the observer's
      // debounced callback reliably fires while the flag is still set —
      // otherwise it can run a redundant apply() right after AJAX
      // pagination has already synchronously re-applied state.
      setTimeout(function(){ isApplying = false; }, 200);
    }
  }

  // -----------------------------------------------------------------------
  // UI sync — active option styling, trigger labels (preview 2), Clear-all
  // visibility, and active-count badge (preview 1).
  // -----------------------------------------------------------------------
  function activeCount(){
    var n = 0;
    if(state.stock){ n++; }
    if(state.size){ n++; }
    if(state.sort && state.sort !== DEFAULT_SORT){ n++; }
    return n;
  }

  function syncUi(){
    $container.find('[data-filter-group]').each(function(){
      var $group = $(this);
      var group = $group.attr('data-filter-group');
      var current = state[group] || '';
      $group.find('[data-filter-value]').each(function(){
        var v = this.getAttribute('data-filter-value') || '';
        var active = (v === current);
        $(this).toggleClass('is-active', active)
          .attr('aria-checked', active ? 'true' : 'false')
          .attr('aria-selected', active ? 'true' : 'false');
      });
    });

    // Preview 2 trigger labels mirror the active option text.
    $container.find('[data-filter-trigger][data-filter-group]').each(function(){
      var $trigger = $(this);
      var group = $trigger.attr('data-filter-group');
      var current = state[group] || '';
      var $opt = $container.find('[data-filter-group="' + group + '"] [data-filter-value="' + cssEscape(current) + '"]').first();
      var label = $opt.length ? $opt.text().trim() : '';
      if(!label){
        // Default label = the option with empty value (the "All"/"Default" seed)
        label = $container.find('[data-filter-group="' + group + '"] [data-filter-value=""]').first().text().trim();
      }
      $trigger.find('[data-filter-value-label]').text(label);
      $trigger.toggleClass('is-active', !!current);
    });

    // Preview 1 active-count badge.
    var $count = $container.find('[data-filter-active-count]');
    var n = activeCount();
    if(n > 0){ $count.text(n).removeAttr('hidden'); }
    else { $count.text('').attr('hidden', ''); }

    // Clear-all visibility.
    var $clear = $container.find('[data-filter-clear]');
    if(n > 0){ $clear.removeAttr('hidden'); }
    else { $clear.attr('hidden', ''); }

    // Mirror the in-stock state onto the toggle checkbox so it visually
    // matches state after URL hydration / programmatic clears.
    syncToggleUi();
  }

  function cssEscape(s){
    return String(s).replace(/(["\\])/g, '\\$1');
  }

  // -----------------------------------------------------------------------
  // Dropdown open/close. Preview 1 has a single trigger/panel pair; preview
  // 2 has multiple, one per filter group. Both shapes work with the same
  // handlers because we look up the nearest [data-filter-dropdown] (or fall
  // back to the [data-filter-preview] container for preview 1).
  // -----------------------------------------------------------------------
  function panelHost($el){
    var $dd = $el.closest('[data-filter-dropdown]');
    return $dd.length ? $dd : $el.closest('[data-filter-preview]');
  }

  function closeAllPanels(except){
    $container.each(function(){
      var $c = $(this);
      $c.find('[data-filter-dropdown]').each(function(){
        if(except && this === except){ return; }
        $(this).find('[data-filter-panel]').attr('hidden', '');
        $(this).find('[data-filter-trigger]').attr('aria-expanded', 'false');
      });
      // Preview 1 case — no [data-filter-dropdown] wrapper, the panel
      // lives directly under [data-filter-preview].
      if(!$c.find('[data-filter-dropdown]').length){
        if(except !== $c[0]){
          $c.find('[data-filter-panel]').attr('hidden', '');
          $c.find('[data-filter-trigger]').attr('aria-expanded', 'false');
        }
      }
    });
  }

  $(document).on('click', '[data-filter-preview] [data-filter-trigger]', function(evt){
    evt.preventDefault();
    evt.stopPropagation();
    var $trigger = $(this);
    var $host = panelHost($trigger);
    var $panel = $host.find('[data-filter-panel]').first();
    var isOpen = !$panel.prop('hidden');
    closeAllPanels($host[0]);
    if(isOpen){
      $panel.attr('hidden', '');
      $trigger.attr('aria-expanded', 'false');
    } else {
      $panel.removeAttr('hidden');
      $trigger.attr('aria-expanded', 'true');
    }
  });

  // Click outside closes all panels.
  $(document).on('click', function(evt){
    if($(evt.target).closest('[data-filter-preview]').length){ return; }
    closeAllPanels(null);
  });

  // Escape closes panels.
  $(document).on('keydown', function(evt){
    if(evt.key === 'Escape'){ closeAllPanels(null); }
  });

  // -----------------------------------------------------------------------
  // Option click → set state + apply.
  // -----------------------------------------------------------------------
  $(document).on('click', '[data-filter-preview] [data-filter-value]', function(evt){
    evt.preventDefault();
    var $btn = $(this);
    var group = $btn.closest('[data-filter-group]').attr('data-filter-group');
    if(!group){ return; }
    var value = $btn.attr('data-filter-value') || '';
    state[group] = value;
    writeStateToUrl();
    apply();
    // Auto-close on selection in preview 2 (single-purpose dropdowns).
    var $dd = $btn.closest('[data-filter-dropdown]');
    if($dd.length){
      $dd.find('[data-filter-panel]').attr('hidden', '');
      $dd.find('[data-filter-trigger]').attr('aria-expanded', 'false');
    }
  });

  // In-stock toggle. The toggle is a simple boolean control (replaces the
  // earlier 3-option Availability dropdown): checked → `stock='in'`,
  // unchecked → empty (show all).
  function syncToggleUi(){
    $container.find('[data-filter-toggle-input]').each(function(){
      this.checked = (state.stock === 'in');
    });
  }
  $(document).on('change', '[data-filter-preview] [data-filter-toggle-input]', function(){
    state.stock = this.checked ? 'in' : '';
    writeStateToUrl();
    apply();
  });

  // Clear all → reset state.
  $(document).on('click', '[data-filter-preview] [data-filter-clear]', function(evt){
    evt.preventDefault();
    state = { stock: '', size: '', sort: DEFAULT_SORT };
    writeStateToUrl();
    syncToggleUi();
    apply();
  });

  // If the theme's AJAX filter swaps in new product DOM (e.g. via tag
  // navigation), the size dropdown should re-aggregate from the new cards
  // and the current filter state should be re-applied. Reorders we perform
  // ourselves are skipped via the `isApplying` flag so we don't feed our
  // own DOM writes back into apply().
  function observeGrid(){
    var container = document.querySelector('[data-ajax-products]');
    if(!container || !window.MutationObserver){ return; }
    var debounce = null;
    var lastCardCount = $cards().length;
    var observer = new MutationObserver(function(records){
      if(isApplying){ return; }
      // Only react to real card-set changes (AJAX swaps add/remove cards),
      // not to our own reorder writes. A pure reorder leaves card count
      // identical even though it still produces childList records.
      var hasRealChange = false;
      for(var i = 0; i < records.length; i++){
        if(records[i].addedNodes.length || records[i].removedNodes.length){
          // Still possibly a move — confirm by comparing counts post-batch.
          hasRealChange = true;
          break;
        }
      }
      if(!hasRealChange){ return; }
      clearTimeout(debounce);
      debounce = setTimeout(function(){
        var nowCount = $cards().length;
        if(nowCount !== lastCardCount){
          lastCardCount = nowCount;
          populateSizeOptions();
          apply();
        }
      }, 50);
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  function markWrapper(){
    // Signal that the client-side filter engine is live so the CSS
    // overrides on `.collection-product-list.has-client-filter` (in
    // custom.css) activate and the JS-managed row-start clearfix wins
    // over the theme's static `:nth-child(3n+1)` rule.
    $('.collection-product-list').addClass('has-client-filter');
  }

  // Carry the active `filter_size` value into every product card link on
  // the collection so a click-through to the PDP can pre-select that
  // size. Always strips any pre-existing `filter_size` param before
  // appending the current one so toggling sizes (or clearing) cleans the
  // hrefs back to their canonical form.
  function rewriteProductLinks(){
    $('.product-block a[href]').each(function(){
      var href = this.getAttribute('href');
      if(!href || href.charAt(0) === '#'){ return; }
      if(href.indexOf('/products/') === -1){ return; }
      // Strip any previous filter_size param. Two-step replace handles
      // both `?filter_size=X` and `&filter_size=X` cleanly.
      href = href.replace(/([?&])filter_size=[^&]*(&|$)/g, function(_, lead, trail){
        return trail === '&' ? lead : (lead === '?' ? '' : '');
      });
      if(state.size){
        var sep = href.indexOf('?') > -1 ? '&' : '?';
        href = href + sep + 'filter_size=' + encodeURIComponent(state.size);
      }
      this.setAttribute('href', href);
    });
  }

  $(document).ready(function(){
    markWrapper();
    populateSizeOptions();
    hydrateStateFromUrl();
    apply();
    observeGrid();
  });

  // Re-apply filter state synchronously after AJAX pagination swaps in new
  // cards, so users never see a flash of unfiltered content on the new page.
  // The size dropdown also re-aggregates because page 2/3/… may surface a
  // different set of sizes than page 1.
  $(document).on('ajax-pagination:swapped', function(){
    markWrapper(); // pagination swapped inner HTML, so re-add the marker
    populateSizeOptions();
    // The URL changed but our in-memory state stays — we want filters to
    // persist across pages exactly as the brief asked. We don't re-hydrate
    // from the URL here (that would only matter on a fresh load, which is
    // handled in ready() above).
    apply();
  });
})();

/* ============================================================================
 * AJAX pagination for the collection grid
 * --------------------------------------------------------------------------
 * Intercepts clicks on `.pagination a` links and swaps in the next/prev
 * page's product grid via XHR instead of doing a full page navigation.
 * This is what keeps the client-side filter preview's in-memory state
 * alive when the customer moves between pages — the previous URL-param
 * round-trip approach was unreliable in some app/theme combos that
 * stripped unknown query strings from Shopify-generated pagination URLs.
 *
 * The filter preview engine still mirrors state to URL params for
 * bookmarking and direct/refreshed loads — those two layers cooperate:
 *   1. AJAX pagination keeps in-memory state alive across page hops.
 *   2. URL params keep state alive across full reloads / shared links.
 *
 * Scope: only `.pagination a` links inside the collection product list.
 * No infinite scroll, no scroll-restoration, no history-state magic for
 * unrelated navigation. Falls back to a full nav if the XHR fails.
 * ========================================================================== */
(function ajaxPaginationInit(){
  var PAGINATION_WRAPPER = '.collection-product-list';
  var $body = $('html, body');
  var inFlight = false;
  var hasPushed = false;

  function findScrollTarget(){
    // Scroll to whichever filter-related element sits highest on the page,
    // so the customer always lands on the filter bar after pagination —
    // not at the top of the page (which buries the filters) and not at
    // the grid top (which hides the filter chrome they're still using).
    // Falls back to the product list when no filter UI is rendered.
    var candidates = [
      '[data-filter-preview]',
      '[data-applied-filters]:not([hidden])',
      '.collection-toolbar',
      '.collection-product-list'
    ];
    for(var i = 0; i < candidates.length; i++){
      var $el = $(candidates[i]).first();
      if($el.length && $el.is(':visible')){
        return Math.max(0, $el.offset().top - 80);
      }
    }
    return 0;
  }

  function swap(url, options){
    options = options || {};
    if(inFlight){ return; }
    var $wrapper = $(PAGINATION_WRAPPER).first();
    if(!$wrapper.length){
      window.location = url;
      return;
    }

    inFlight = true;

    // Subtle fade while fetching — same idea as the theme's own AJAX
    // filter (CollectionTemplate.changeUrl). Apply to the whole wrapper
    // so the pagination links fade together with the grid.
    var prevTransition = $wrapper.css('transition');
    $wrapper.css({
      transition: 'opacity 200ms ease',
      opacity: 0.35,
      pointerEvents: 'none'
    });

    $.get(url).done(function(html){
      var $doc = $('<div>').append($.parseHTML(html));
      var $newWrapper = $doc.find(PAGINATION_WRAPPER).first();

      if($newWrapper.length){
        // Replace the wrapper's inner HTML wholesale rather than emptying
        // .grid and appending children. That guarantees the grid wrapper
        // div, its classes (grid grid--uniform grid--uniform-row-gutters
        // large-row), the per-card grid_class (grid__item one-third …),
        // and any whitespace/text nodes between siblings all come from
        // the response exactly as the server rendered them — so the
        // 3-column layout never drifts after a swap.
        $wrapper.html($newWrapper.html());
      }

      $wrapper.css({
        transition: prevTransition || '',
        opacity: '',
        pointerEvents: ''
      });

      var newTitle = $doc.find('title').first().text();
      if(newTitle){ document.title = newTitle; }

      if(!options.skipPushState){
        window.history.pushState({ ajaxPagination: true }, newTitle || document.title, url);
        hasPushed = true;
      }

      // Notify the filter preview (and anything else interested) so it can
      // re-apply state to the newly-rendered cards synchronously.
      $(document).trigger('ajax-pagination:swapped', { url: url });

      // Scroll up to the filter bar AFTER the new content is in place, so
      // the customer's viewport lands on the filters rather than wherever
      // they were on the previous page. Skipped on popstate (back/forward)
      // because browsers handle scroll restoration themselves there.
      if(!options.skipScroll){
        var target = findScrollTarget();
        $body.stop(true).animate({ scrollTop: target }, 500);
      }
    }).fail(function(){
      // Network/server error — fall back to a real navigation so the user
      // still gets to the page they clicked.
      window.location = url;
    }).always(function(){
      inFlight = false;
    });
  }

  // Intercept pagination link clicks. Honour modifier-keys (cmd/ctrl click,
  // middle-click) so "open in new tab" still works.
  $(document).on('click', '.pagination a[href]', function(evt){
    if(evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey || evt.which === 2){ return; }
    var href = this.getAttribute('href');
    if(!href || href.charAt(0) === '#'){ return; }
    // Only intercept same-origin links — anything that points elsewhere is
    // not pagination, so leave it to the browser.
    var a = document.createElement('a');
    a.href = href;
    if(a.host && a.host !== location.host){ return; }
    evt.preventDefault();
    swap(href);
  });

  // Browser back / forward across AJAX-paginated pages.
  $(window).on('popstate.ajaxPagination', function(evt){
    var state = evt.originalEvent && evt.originalEvent.state;
    if(state && state.ajaxPagination){
      swap(location.href, { skipPushState: true, skipScroll: true });
    } else if(hasPushed){
      // Back to a pre-AJAX-pagination history entry (no state token).
      // The URL is already showing the right page — fetch it.
      swap(location.href, { skipPushState: true, skipScroll: true });
    }
  });
})();

/* ============================================================================
 * PDP — auto-select the size carried over from the collection filter
 * --------------------------------------------------------------------------
 * The collection's client-side filter mirrors its active size to a
 * `filter_size` URL param, and `rewriteProductLinks` in the filter engine
 * propagates that param onto every product card link. When the shopper
 * lands on a PDP with `?filter_size=L`, this IIFE finds the Size option
 * selector, sets its value to L, and fires the `change` event so the
 * theme's existing single-option-selector handler picks the matching
 * variant. Graceful fallback when the product doesn't carry that size
 * (we just leave the default selection alone). Skipped entirely on
 * non-product pages — `data-product-json` only exists on PDPs.
 * ========================================================================== */
(function autoSelectFilteredSizeOnPDP(){
  if(!document.querySelector('[data-product-json]')){ return; }

  function readParam(name){
    if(!location.search){ return ''; }
    var pairs = location.search.substr(1).split('&');
    for(var i = 0; i < pairs.length; i++){
      var p = pairs[i].split('=');
      if(decodeURIComponent(p[0]) === name){
        return decodeURIComponent((p[1] || '').replace(/\+/g, ' '));
      }
    }
    return '';
  }

  var targetSize = readParam('filter_size');
  if(!targetSize){ return; }
  var targetLc = targetSize.trim().toLowerCase();

  $(document).ready(function(){
    // Wait one tick so the theme's Product section has had a chance to
    // bind its change handlers on `[data-single-option-selector]`.
    setTimeout(function(){
      var $selectors = $('[data-single-option-selector]');
      if(!$selectors.length){ return; }

      // Prefer the selector whose label is "Size" so a colour option
      // named "L" can never be mistaken for a size value. Fall back to
      // checking every selector if no label matches (defensive — covers
      // localised stores that label the option differently).
      var $sizeSelector = null;
      $selectors.each(function(){
        var $sel = $(this);
        var label = ($('label[for="' + $sel.attr('id') + '"]').text() || '').trim().toLowerCase();
        if(/^size\b/.test(label)){
          $sizeSelector = $sel;
          return false;
        }
      });

      var $candidates = $sizeSelector ? $sizeSelector : $selectors;
      $candidates.each(function(){
        var $sel = $(this);
        var $opt = $sel.find('option').filter(function(){
          return (this.value || '').trim().toLowerCase() === targetLc;
        }).first();
        if(!$opt.length){ return; }
        // Skip if it's already the selected option — triggering change
        // would be a no-op and may double-fire select2 redraws.
        if($sel.val() === $opt.attr('value')){ return false; }
        $sel.val($opt.attr('value'));
        $sel.trigger('change');
        // Nudge select2 if the theme wrapped this select with it, so the
        // visible chrome updates to match the new value.
        if($sel.data('select2')){ $sel.trigger('change.select2'); }
        return false;
      });
    }, 0);
  });
})();

/* ============================================================================
   MOBILE HEADER UI
   Wires up the slide-in left drawer (.mobile-drawer + backdrop) and the
   slide-down search panel (.mobile-search-panel) added in sections/header.liquid.
   Hooks: .js-mobile-drawer-open / .js-mobile-drawer-close
          .js-mobile-search-toggle / .js-mobile-search-close
   Only active when matching elements exist (i.e. on mobile viewports where
   the bar is rendered). Idempotent — safe to load with Shopify section reloads.
   ============================================================================ */
(function mobileHeaderUI() {
  var drawer = document.getElementById('MobileDrawer');
  var backdrop = document.querySelector('.mobile-drawer-backdrop');
  var searchPanel = document.getElementById('MobileSearchPanel');
  if (!drawer && !searchPanel) { return; }

  var drawerOpenBtn = document.querySelector('.js-mobile-drawer-open');
  var searchToggleBtn = document.querySelector('.js-mobile-search-toggle');
  var searchInput = searchPanel ? searchPanel.querySelector('.mobile-search-panel__input') : null;
  var lastFocused = null;

  function openDrawer() {
    if (!drawer) { return; }
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (backdrop) {
      backdrop.classList.add('is-open');
      backdrop.setAttribute('aria-hidden', 'false');
    }
    if (drawerOpenBtn) { drawerOpenBtn.setAttribute('aria-expanded', 'true'); }
    document.body.classList.add('mobile-drawer-open');
    // Defer focus until after transition starts so iOS doesn't fight it
    setTimeout(function () { try { drawer.focus(); } catch (_) {} }, 50);
  }

  function closeDrawer() {
    if (!drawer) { return; }
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (backdrop) {
      backdrop.classList.remove('is-open');
      backdrop.setAttribute('aria-hidden', 'true');
    }
    if (drawerOpenBtn) { drawerOpenBtn.setAttribute('aria-expanded', 'false'); }
    document.body.classList.remove('mobile-drawer-open');
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus(); } catch (_) {}
    }
  }

  function openSearch() {
    if (!searchPanel) { return; }
    searchPanel.classList.add('is-open');
    searchPanel.setAttribute('aria-hidden', 'false');
    if (searchToggleBtn) { searchToggleBtn.setAttribute('aria-expanded', 'true'); }
    // Auto-focus on input so the soft keyboard opens immediately on mobile.
    // A short delay lets the transition begin before focus lands.
    setTimeout(function () {
      if (searchInput) { try { searchInput.focus(); } catch (_) {} }
    }, 60);
  }

  function closeSearch() {
    if (!searchPanel) { return; }
    searchPanel.classList.remove('is-open');
    searchPanel.setAttribute('aria-hidden', 'true');
    if (searchToggleBtn) { searchToggleBtn.setAttribute('aria-expanded', 'false'); }
    if (searchInput) { try { searchInput.blur(); } catch (_) {} }
  }

  function toggleSearch() {
    if (!searchPanel) { return; }
    if (searchPanel.classList.contains('is-open')) { closeSearch(); } else { openSearch(); }
  }

  function toggleSubmenu(toggleBtn) {
    var item = toggleBtn.closest('.mobile-drawer__item');
    if (!item) { return; }
    var nowOpen = !item.classList.contains('is-open');

    // Accordion: when opening, collapse any sibling submenu first so only
    // one stays open at a time.
    if (nowOpen) {
      var siblings = item.parentNode
        ? item.parentNode.querySelectorAll(':scope > .mobile-drawer__item.is-open')
        : [];
      for (var i = 0; i < siblings.length; i++) {
        if (siblings[i] === item) { continue; }
        siblings[i].classList.remove('is-open');
        var sibToggle = siblings[i].querySelector(':scope > .mobile-drawer__row > .mobile-drawer__toggle');
        if (sibToggle) { sibToggle.setAttribute('aria-expanded', 'false'); }
        var sibList = siblings[i].querySelector(':scope > .mobile-drawer__sublist');
        if (sibList) { sibList.setAttribute('hidden', ''); }
      }
    }

    item.classList.toggle('is-open', nowOpen);
    toggleBtn.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
    // The [hidden] attribute on the sublist gates display; mirror state to it
    // so the CSS .is-open > .mobile-drawer__sublist rule wins predictably.
    var sublist = item.querySelector(':scope > .mobile-drawer__sublist');
    if (sublist) {
      if (nowOpen) { sublist.removeAttribute('hidden'); }
      else { sublist.setAttribute('hidden', ''); }
    }
  }

  // Delegated click handling — survives section re-renders in the editor.
  document.addEventListener('click', function (evt) {
    var t = evt.target.closest ? evt.target.closest(
      '.js-mobile-drawer-open, .js-mobile-drawer-close, .js-mobile-search-toggle, .js-mobile-search-close, .js-mobile-drawer-submenu-toggle'
    ) : null;
    if (!t) { return; }
    if (t.matches('.js-mobile-drawer-open')) {
      evt.preventDefault();
      // Close search if it's open so they don't stack.
      closeSearch();
      openDrawer();
    } else if (t.matches('.js-mobile-drawer-close')) {
      evt.preventDefault();
      closeDrawer();
    } else if (t.matches('.js-mobile-search-toggle')) {
      evt.preventDefault();
      toggleSearch();
    } else if (t.matches('.js-mobile-search-close')) {
      evt.preventDefault();
      closeSearch();
    } else if (t.matches('.js-mobile-drawer-submenu-toggle')) {
      evt.preventDefault();
      toggleSubmenu(t);
    }
  });

  // Escape closes whichever overlay is open.
  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape' && evt.keyCode !== 27) { return; }
    if (drawer && drawer.classList.contains('is-open')) { closeDrawer(); }
    else if (searchPanel && searchPanel.classList.contains('is-open')) { closeSearch(); }
  });

  // If the viewport is resized up to desktop while overlays are open, clean up.
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 750) {
      if (drawer && drawer.classList.contains('is-open')) { closeDrawer(); }
      if (searchPanel && searchPanel.classList.contains('is-open')) { closeSearch(); }
    }
  });
})();